
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

import PerformanceActivitiesService from '@/api/PerformanceActivitiesService';

import FilterByCampaigns from '@/componentsV2/organisms/FilterByCampaigns/FilterByCampaigns.vue';

import Typography from '@/components/atoms/Typography/Typography.vue';

import OfferFreeCoinsService from '@/api/OfferFreeCoinsService';
import DateUtils from '@/utils/DateUtils';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    AnalyticsCardList,
    FilterByCampaigns,
    Typography
  }
})
export default class ActivitiesOverviewFreeCoinsCampaigns extends Vue {
  @Prop() filters!: Record<string, any>;
  @Prop({ default: true }) showRequestLoading?: boolean;

  performanceActivitiesService: PerformanceActivitiesService = new PerformanceActivitiesService();
  freeCoinsService: OfferFreeCoinsService = new OfferFreeCoinsService();

  hasCampaigns: boolean = false;
  hasActiveCampaign: boolean = false;
  selectedCampaign: string = '';

  campaignCreatedAt: string = '';

  initSelectedCampaign: string = 'lifetime';

  analytics: Record<string, AnalyticsCardListItem> = {
    coinsClaimed: {
      infos: {
        title: 'Coins claimed',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    },
    customersWhoClaimed: {
      infos: {
        title: 'Members who claimed',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    },
    customerLimit: {
      hidden: true,
      infos: {
        title: 'Member limit',
        amount: 0,
        tooltipText: '',
        insightText: '',
        disableAbbreviateAmount: true
      }
    },
    customerLimitTotal: {
      hidden: true,
      infos: {
        title: 'Member limit',
        amount: 0,
        tooltipText: '',
        insightText: '',
        disableAbbreviateAmount: true
      }
    }
  };

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return `performance.activities.campaignActivity.tabs.welcomeCoinsCampaigns`;
  }

  get translatedAnalytics() {
    return Object.entries(this.analytics)
      .map(([key, value]) => ({
        ...value,
        infos: {
          ...value.infos,
          tooltipText: this.$t(`${this.tPrefix}.${key}.tooltip`)
        }
      }))
      .filter(({ hidden }) => !hidden);
  }

  get campaigns() {
    return [
      {
        label: 'Active Campaign',
        value: 'active',
        disabled: !this.hasActiveCampaign
      },
      {
        label: 'Lifetime data',
        value: 'lifetime',
        disabled: !this.hasCampaigns
      }
    ];
  }

  get linkSeeAll() {
    return this.hasCampaigns ? '/marketing-center/offer-free-coins' : '';
  }

  @Watch('filters')
  async getOverview() {
    if (this.showRequestLoading) {
      this.$showLoaderWithLocker();
    }

    let endpointPath = `/v2/admin/firstcoin-campaign/reports`;

    const response = await this.performanceActivitiesService.getActivitiesOverview(
      endpointPath,
      this.filters
    );

    this.$hideLoader();

    if (response.status !== 200) return;

    const {
      totalCoinsReward,
      customersClaimed,
      customersRedeem,
      customerLimit,
      typeLimit,
      firstcoin_campaign_createdAt
    } = response.data;

    this.analytics.coinsClaimed.infos.amount = totalCoinsReward;

    const customersWhoClaimed =
      Number(totalCoinsReward) / Number(customersClaimed);
    const customersWhoClaimedInsightText =
      customersWhoClaimed >= 0
        ? `${customersWhoClaimed.toFixed(0)} ${this.$tc(
            `common.pluralize.coin`,
            Number(customersWhoClaimed) || 1
          )} per member `
        : '';

    this.analytics.customersWhoClaimed.infos.amount = customersClaimed;
    this.analytics.customersWhoClaimed.infos.insightText =
      this.selectedCampaign === 'active' ? customersWhoClaimedInsightText : '';

    if (customerLimit) {
      const customerLimitAmount = `${customersRedeem}/${customerLimit}`;
      if (typeLimit === 'daily-customer') {
        this.analytics.customerLimit.infos.amount = customerLimitAmount;
        this.analytics.customerLimit.infos.insightText = `Per day`;
        this.analytics.customerLimit.hidden = false;
        this.analytics.customerLimitTotal.hidden = true;
      } else {
        this.analytics.customerLimitTotal.infos.amount = customerLimitAmount;
        this.analytics.customerLimitTotal.infos.insightText = `${customerLimit} total customers`;
        this.analytics.customerLimitTotal.hidden = false;
        this.analytics.customerLimit.hidden = true;
      }
    } else {
      this.analytics.customerLimit.hidden = true;
      this.analytics.customerLimitTotal.hidden = true;
    }

    this.campaignCreatedAt =
      this.selectedCampaign === 'active' && firstcoin_campaign_createdAt
        ? DateUtils.formattedDate({ date: firstcoin_campaign_createdAt })
        : '';
  }

  async getOffersAndCampaigns() {
    const response = await this.freeCoinsService.listOfferFreeCoins();

    const listOfferFreeCoins = response.data.items;

    this.hasCampaigns = !!listOfferFreeCoins.length;
    this.hasActiveCampaign = !!listOfferFreeCoins.filter(
      (campaign: any) => campaign.status === 'active'
    ).length;
  }

  handleFilterByCampaign(campaign: any) {
    this.selectedCampaign = campaign;
    this.$emit('change-filter', { type: this.selectedCampaign });
  }

  created() {
    this.getOffersAndCampaigns();
  }
}
